import Fuse from 'fuse.js'

const toolSearchOptions = {
  ignoreLocation: true,
  keys: [
    { name: 'title', weight: 4 },
    { name: 'aliases', weight: 3 },
    { name: 'teams', weight: 2.5 },
    { name: 'tags', weight: 2 },
    { name: 'category', weight: 1.5 },
    { name: 'description', weight: 1 },
    { name: 'key', weight: 0.5 },
  ],
}

export function searchInternalTools(items, query) {
  const normalizedQuery = query.trim()
  if (!normalizedQuery) return items

  const threshold = normalizedQuery.length <= 3 ? 0.3 : 0.35

  return new Fuse(items, { ...toolSearchOptions, threshold })
    .search(normalizedQuery)
    .map((result) => result.item)
}
